var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z",
    fill: "#EAFAF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8337 26.3333V17.1667M9.66699 18.8333V24.6667C9.66699 25.5871 10.4132 26.3333 11.3337 26.3333H22.5222C23.7561 26.3333 24.8055 25.4331 24.9931 24.2135L25.8906 18.3801C26.1235 16.8658 24.9518 15.5 23.4196 15.5H20.5003C20.0401 15.5 19.667 15.1269 19.667 14.6667V11.7215C19.667 10.5867 18.747 9.66667 17.6121 9.66667C17.3414 9.66667 17.0961 9.82608 16.9862 10.0734L14.0536 16.6718C13.9199 16.9727 13.6214 17.1667 13.2921 17.1667H11.3337C10.4132 17.1667 9.66699 17.9129 9.66699 18.8333Z",
    stroke: "#1F7A50",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeActive);
export default __webpack_public_path__ + "static/media/likeActive.3048b94a88fe62b1ea481793239fced2.svg";
export { ForwardRef as ReactComponent };